import { Alert as AntAlert } from 'antd';

export const badWords = [' and ', ' or ', ' not ', '*'];

export const validationErrors = {
  MAX_KEYWORD_LENGTH: 'MAX_KEYWORD_LENGTH',
};

export const errors = {
  [validationErrors.MAX_KEYWORD_LENGTH]: (
    <AntAlert
      style={{ marginTop: 15 }}
      type='error'
      message='Keywords must not be more than 50 characters.'
    />
  ),
};

export const showWarning = value =>
  badWords.some(w => value.toLowerCase().includes(w));

export const Alert = () => (
  <AntAlert
    style={{ marginTop: 15 }}
    type='info'
    message='Boolean operators and wildcards will not apply so we recommend that you do not add them to the keyword list.'
  />
);

export const getFirstApiValidationError = error =>
  (error.status === 400 &&
    (Object.values(error.errors)?.[0]?.[0] || error.message)) ||
  'Failed to add keyword';
